export default __webpack_public_path__ + "static/media/senthilmukusha.1b172a39.png";